import * as ActionTypes from '../ActionTypes';

export const GetAtsProfileScoreAction = (params) => {
    return {
        type: ActionTypes.ATS_PROFILE_SCORE_GET_REQUEST,
        params
    }
}

export const GetAtsPythonProfileScoreAction = (params, callback) => {
    return {
        type: ActionTypes.ATS_PYTHON_PROFILE_SCORE_GET_REQUEST,
        params,
        callback
    }
}

export const GetAtsPythonAIJobCreationAction = (params, callback) => {
    return {
        type: ActionTypes.ATS_PYTHON_JOB_CREATION_GET_REQUEST,
        params,
        callback
    }
}

export const GetAtsPythonResumeCSVDataAction = (params, callback) => {
    return {
        type: ActionTypes.ATS_PYTHON_CSV_DATA_GET_REQUEST,
        params,
        callback
    }
}

export const GetAtsPythonPreScreenScoreAction = (params, callback) => {
    return {
        type: ActionTypes.ATS_PYTHON_SCREENING_SCORE_GET_REQUEST,
        params,
        callback
    }
}